export const reasonForMismatchModalStyles = {
  dialogPaper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  root: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    pb: 3,
    pt: 2,
    px: 2,
    borderRadius: '16px 16px 0 0',
  },
  titleRow: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    width: '100%',
  },
  titleText: {
    flex: 1,
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
    lineHeight: 1.6,
  },
  closeButton: {
    width: 24,
    height: 24,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
  },
  optionRow: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'center',
    cursor: 'pointer',
    width: '100%',
  },
  radioOuter: {
    p: '9px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100px',
  },
  radioInner: {
    width: 24,
    height: 24,
    position: 'relative',
  },
  optionText: {
    flex: 1,
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
    lineHeight: 1.75,
  },
  customReasonWrap: {
    mt: 2,
    ml: 6,
  },
  customReasonInput: {
    '& .MuiOutlinedInput-root': {
      fontFamily: "'Noto Sans', sans-serif",
      fontSize: 14,
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#007CBF',
      },
    },
  },
  divider: {
    width: '100%',
    height: '1px',
    bgcolor: '#E3E6E9',
    mt: 2,
  },
};
